/* AFIQ redesign · FAQ page (/pages/faq): price tokens, search, section highlight, FAQPage JSON-LD.
   Loaded with defer by sections/afiq-faq-main + afiq-faq-band (guarded, runs once), after afiq-shop.js. */
(function () {
  'use strict';
  if (window.__afiqFaqInit || !window.AFIQ_UI) return;
  window.__afiqFaqInit = true;
  /* Price/tier tokens, filled from live AFIQ data (never hard-coded). Same helper in afiq-contact/faq/filmroom/quiz/reviews.js. */
  function afiqFill(html) {
    var U = window.AFIQ_UI, A = window.AFIQ, P = U.P, $ = U.$, L = A.LADDER || [];
    var vols = U.VOLS, e = U.priceDecks(vols), top = L[L.length - 1] || { min: 0, pct: 0 };
    var cards = vols.reduce(function (s, id) { return s + (+P[id].cards || 54); }, 0);
    var ladder = function (unit) {
      return L.map(function (t, i) {
        var nx = L[i + 1], label = !nx ? t.min + ' or more' : (nx.min - 1 > t.min ? t.min + '–' + (nx.min - 1) + ' decks' : t.min + ' decks');
        var price = unit ? ' (' + $(A.unitCents(t.min)) + (i === 0 ? ' each' : '') + ')' : '';
        return label + ' ' + t.pct + '%' + (i === 0 ? ' off' : '') + price;
      }).join(', ');
    };
    var map = {
      elite_total: $(e.total), elite_full: $(e.full), elite_save: $(e.save), elite_cards: String(cards),
      ladder: ladder(true), ladder_short: ladder(false),
      top_min: String(top.min), top_pct: String(top.pct), top_unit: $(A.unitCents(top.min)),
      volumes: vols.map(function (d) { return '<b>' + U.esc(P[d].label) + ': ' + U.esc(P[d].title) + '</b>: ' + U.esc(P[d].hook); }).join('<br>'),
      fl5_hook: P.fl5 ? U.esc(P.fl5.hook) : ''
    };
    return String(html)
      .replace(/\{basics_discounted:([^|}]*)\|([^}]*)\}/g, function (m, yes, no) { return U.basicsDiscounted ? yes : no; })
      .replace(/\{pct_(\d+)\}/g, function (m, n) { return String(A.tier(+n).pct); })
      .replace(/\{unit_(\d+)\}/g, function (m, n) { return $(A.unitCents(+n)); })
      .replace(/\{([a-z0-9_]+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; });
  }
  function afiqFillAll(root) {
    root = root || document;
    root.querySelectorAll('[data-afiq-tpl]').forEach(function (el) { el.innerHTML = afiqFill(el.getAttribute('data-afiq-tpl')); });
    root.querySelectorAll('[data-afiq-fill]').forEach(function (el) { el.innerHTML = afiqFill(el.innerHTML); });
  }
  function track(n, p) { try { window.AFIQ_UI.track(n, p); } catch (e) {} }

  afiqFillAll();
  var root = document.querySelector('[data-afiq-faq]');
  if (!root) return;
  var qs = Array.prototype.slice.call(root.querySelectorAll('details[data-q]'));
  qs.forEach(function (d) { d.innerHTML = afiqFill(d.innerHTML); });

  /* FAQPage structured data: the same (filled) text the visitor reads. */
  var text = function (el) { return (el ? el.textContent : '').replace(/\s+/g, ' ').trim(); };
  if (qs.length) {
    var ld = { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: qs.map(function (d) {
      var clone = d.cloneNode(true), s = clone.querySelector('summary'); if (s) clone.removeChild(s);
      return { '@type': 'Question', name: text(d.querySelector('summary')), acceptedAnswer: { '@type': 'Answer', text: text(clone) } };
    }) };
    var tag = document.createElement('script'); tag.type = 'application/ld+json'; tag.textContent = JSON.stringify(ld); document.head.appendChild(tag);
  }

  /* Search */
  var input = root.querySelector('[data-faq-q]'), none = root.querySelector('[data-faq-none]'), grps = root.querySelectorAll('.faq-grp'), timer;
  if (input) input.addEventListener('input', function () {
    var t = input.value.trim().toLowerCase(), any = false;
    grps.forEach(function (g) {
      var n = 0;
      g.querySelectorAll('details').forEach(function (d) { var hit = !t || d.textContent.toLowerCase().indexOf(t) > -1; d.hidden = !hit; if (hit) n++; if (t && hit) d.open = true; });
      g.hidden = n === 0; if (n) any = true;
    });
    if (none) none.hidden = any;
    clearTimeout(timer);
    if (t.length > 2) timer = setTimeout(function () { track('afiq_faq_search', { query: t.slice(0, 60), results: any }); }, 1200);
  });

  /* Highlight the group in view */
  var links = Array.prototype.slice.call(root.querySelectorAll('.faq-toc a'));
  if ('IntersectionObserver' in window && links.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (x.isIntersecting) links.forEach(function (a) { a.classList.toggle('on', a.hash === '#' + x.target.id); }); });
    }, { rootMargin: '-30% 0px -60% 0px' });
    grps.forEach(function (g) { io.observe(g); });
  }
})();
